
export class PassService{

   public home:any;
   public ports:string;
   public vendor:any;
   public header:boolean = false;
   public fetchSize:any;

}




// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/PassService.ts